import { render, staticRenderFns } from "./whiteResourcePool.vue?vue&type=template&id=a206031a&scoped=true"
import script from "./whiteResourcePool.vue?vue&type=script&lang=js"
export * from "./whiteResourcePool.vue?vue&type=script&lang=js"
import style0 from "./whiteResourcePool.vue?vue&type=style&index=0&id=a206031a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a206031a",
  null
  
)

export default component.exports